/*
THIS INFRAGISTICS ULTIMATE SOFTWARE LICENSE  AGREEMENT ("AGREEMENT") LOCATED HERE:
https://www.infragistics.com/legal/license/igultimate-la
https://www.infragistics.com/legal/license/igultimate-eula
GOVERNS THE LICENSING, INSTALLATION AND USE OF INFRAGISTICS SOFTWARE. BY DOWNLOADING AND/OR INSTALLING AND USING INFRAGISTICS SOFTWARE:  you are indicating that you have read and understand this Agreement, and agree to be legally bound by it on behalf of the yourself and your company.
*/
import * as tslib_1 from "tslib";
import { Base, markType } from "./type";
/**
 * @hidden
 */
var TouchGestureEventArgs = /** @class */ /*@__PURE__*/ (function (_super) {
    tslib_1.__extends(TouchGestureEventArgs, _super);
    function TouchGestureEventArgs() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.d = 0;
        _this.e = 0;
        _this.c = 0;
        _this.f = 0;
        _this.g = 0;
        _this.a = 0;
        _this.b = 0;
        _this.h = 0;
        _this.i = 0;
        return _this;
    }
    TouchGestureEventArgs.$t = markType(TouchGestureEventArgs, 'TouchGestureEventArgs');
    return TouchGestureEventArgs;
}(Base));
export { TouchGestureEventArgs };
//# sourceMappingURL=TouchGestureEventArgs.js.map
